'use client';
import Page from '@/pages/Settings';
export default Page;